import { RECEIVE_CURRENCY_FORMAT } from '../actions/page';

export const CUSTOM_LOCALE_MAP = {
  de_EE: 'de_DE',
  de_FI: 'de_DE',
  de_LV: 'de_DE',
  de_SK: 'de_DE',
  fr_BE: 'fr_FR',
  fr_LU: 'fr_FR',
  en_EU: 'en_BE',
  en_CZ: 'en_BE',
  en_EE: 'en_BE',
  en_FI: 'en_BE',
  en_FR: 'en_BE',
  en_GR: 'en_BE',
  en_HU: 'en_BE',
  en_LU: 'en_BE',
  en_LV: 'en_BE',
  en_PL: 'en_BE',
  en_PT: 'en_BE',
  en_SE: 'en_BE',
  en_SK: 'en_BE',
};

export const loadCurrencyFormat = async (store, locale) => {
  const localeToLoad = CUSTOM_LOCALE_MAP[locale] || locale;
  try {
    const module = await import(
      /* webpackChunkName: "currency-locale-[request]" */ `../constants/currencyFormats/angular-locale_${localeToLoad.toLowerCase().replace('_', '-')}.json`
    );
    const currencyFormat = module.default;
    return store.dispatch({
      type: RECEIVE_CURRENCY_FORMAT,
      data: {
        currencyFormat,
      },
    });
  } catch (_err) {
    console.log(`${localeToLoad} file is missing, falling back to en_US`);
    const currencyFormat = await import(
      /* webpackChunkName: "currency-locale-[request]" */ `../constants/currencyFormats/angular-locale_en-us.json`
    );
    return store.dispatch({
      type: RECEIVE_CURRENCY_FORMAT,
      data: {
        currencyFormat,
      },
    });
  }
};
